module.exports = __webpack_public_path__ + "img/CR.74dd61b6.svg";